import { General } from "./metafiles"

export const BrowsingInstance = Object.freeze({
  root : 'root' ,
  category : 'category' ,
  pattern : 'pattern'
});

export default class AppInstance {
  constructor (c) {
    if (!this._instance) {
      this._instance = {
        canvas :  {},
        rulerX :  {},
        rulerY :  {},
        jobData :  {},
        files :  [],
        color_set :  {} ,
        swatches :  [],
        selected :  { colors: [], id: '', external_id: '', name: '', variationName: '',  original_zones: [], metadata: null, tags: [], parent: null, rasterChildren: null },
        initial_colorset :  {} ,
        m_patterns :  [],
        doc_figures :  {} ,
        is_raster :  false ,
        path : "" ,
        category_metafiles :  {},
        zone_color_map :  [],
        is_designer :  false ,
        favorites_events_registered :  false ,
        favorites :  [],
        favorite_tuples: [],
        max_zoom_level :  10,
        min_zoom_level :  1,
        pattern_set_name_production :  "/" + c.SETNAMEPRODUCTION,
        pattern_set_name :  "/" + c.SETNAME,
        CUSTOMER_HASH: c.CUSTOMER_HASH ,
        colorSwatch :  $(".choose-color-swatch promo-masonry promos") ,
        previous_path: "",
        active_search: false,
        editParams: {
          jobData: {}
        },
        FIELDNAME: "",
        STEPINDEX: "",
        EDITPATTERNID: "",
        GROUPID: "",
        SHOPPERID: ""
      };
    }
  }
  reset_selected() {
    this._instance.selected = { colors: [], id: '', external_id: '', name: '', variationName: '',  original_zones: [], metadata: null, tags: [], thumb_url:'', variationName: '', parent: null, rasterChildren: null, is_favorite: false };
  }
  reset() {
    this.files = [];
    this.color_set = {} ;
    this.swatches = [];
    this.selected = { colors: [], id: '', external_id: '', name: '', variationName: '',  original_zones: [], metadata: null, tags: [], thumb_url:'', variationName: '', parent: null, rasterChildren: null, is_favorite: false };
    this.initial_colorset = {} ;
    this.doc_figures = {} ;
    this.zone_color_map = [];
    this.favorite_tuples = [],
    // this.category_metafiles.header = null ;
    // this.category_metafiles.logo = null ;
    this.is_designer = false ;
    this.is_favorite_search = false ;
    this.active_search = false ;
    //this._instance.favorites = [];
    this.editParams = {
      jobData: {}
    }
  }
  instance() {
    return this._instance ;
  }
  resetCategory() {
    this.category_metafiles = {};
    this.path = '' ;
  }
  setCustomer(hash, shopper) {
    this._instance.CUSTOMER_HASH = hash ;
    this._instance.shopperId = shopper ;
  }
  browsing() {
    if ( this._instance.selected && this._instance.selected.id.length > 0 )
      return BrowsingInstance.pattern ;
    else if ( this.is_category() )
      return BrowsingInstance.category ;
    else
      return BrowsingInstance.root ;
  }
  is_design_house()
  {
    return ( ( this._instance.path !== undefined ) && ( this._instance.path.split(/[/]+/).length === General.category_root_level + 1 ) && ( this._instance.m_patterns.length === 0 ) );
  }
  is_category()
  {
    return ( ( this._instance.path !== undefined ) && ( this._instance.path.split(/[/]+/).length >= General.category_root_level + 1 ) && this.active_search === false );
  }
  is_root()
  {
    return ( ( ! this.is_design_house() ) && ( ! this.is_category() ) );
  }
  is_art_uploader()
  {
    return ( ( this._instance.FIELDNAME ) && (  this._instance.STEPINDEX ) && ( this._instance.FIELDNAME.length > 0 ) && ( this._instance.STEPINDEX > 0 ) )
  }
  pattern_to_load()
  {
    return ( this._instance.editParams && this._instance.editParams.jobData && this._instance.editParams.jobData.description && this._instance.editParams.jobData.description.patternId ? this._instance.editParams.jobData.description.patternId : undefined );
  }
}